import { generateKey as generate } from '@wix/settings-key-format';
import { SettingsParamType, } from './types';
var DEFAULT_LANGUAGE = 'en';
export var generateKey = function (param, _a) {
    var isMobile = _a.isMobile, _b = _a.language, language = _b === void 0 ? DEFAULT_LANGUAGE : _b;
    if (typeof param.dangerousKeyTransformationOverride === 'function') {
        // Please, use `dangerousKeyTransformationOverride` only for migration purposes!
        return param.dangerousKeyTransformationOverride(param.key, {
            isMobile: isMobile,
            language: language,
        });
    }
    return generate(param.key, { m: isMobile, l: language }, { m: false, l: DEFAULT_LANGUAGE });
};
export var isParamTranslatable = function (param) {
    return param.type === SettingsParamType.Text;
};
export var generateKeyVariations = function (param, options) {
    var languageAndMobile = generateKey(param, {
        isMobile: options.isMobile,
        language: options.language,
    });
    var language = generateKey(param, {
        isMobile: false,
        language: options.language,
    });
    var mobile = generateKey(param, {
        isMobile: options.isMobile,
    });
    return {
        languageAndMobile: languageAndMobile,
        language: language,
        mobile: mobile,
        original: param.key,
    };
};
//# sourceMappingURL=generateKey.js.map